import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ModelImage } from './model-image.model';
import { ModelImagePopupService } from './model-image-popup.service';
import { ModelImageService } from './model-image.service';

@Component({
    selector: 'dcs-model-image-delete-dialog',
    templateUrl: './model-image-delete-dialog.component.html'
})
export class ModelImageDeleteDialogComponent {

    modelImage: ModelImage;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private modelImageService: ModelImageService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['modelImage']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.modelImageService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'modelImageListModification',
                content: 'Deleted an modelImage'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'dcs-model-image-delete-popup',
    template: ''
})
export class ModelImageDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private modelImagePopupService: ModelImagePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.modelImagePopupService
                .open(ModelImageDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model-image/model-image-delete-dialog.component.ts